import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPlayers, fetchPeriods } from '../../utils/ifrData';
import { isActive, periodKeyOf, periodLabel } from '../../utils/ifr';
import { RATING_CATEGORIES, fieldsFor } from '../../config/ratingCategories';
import { fmtDate } from '../../utils/weekUtils';

// ── UKURASA WA KUCHAPISHA / KUPAKUA PDF — Orodha Rasmi ya IFR ──────────
// Hadharani, kama RatingList — lakini umbo la karatasi safi la "Print to
// PDF", ili iwe rahisi kuwapa watu nakala (kasi zote tatu kwa pamoja).

export default function RatingListPrint() {
  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);
  const [period, setPeriod] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([fetchPlayers(), fetchPeriods()])
      .then(([ps, periods]) => { setPlayers(ps); setPeriod(periods[0] || null); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: '40px', fontFamily: 'sans-serif' }}>Inapakia...</div>;

  const cur = periodKeyOf();

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: '#F6F4EE', minHeight: '100vh', padding: '24px 16px' }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: #fff !important; }
          .sheet { box-shadow: none !important; border: none !important; }
          .cat-section { break-before: page; }
          .cat-section:first-child { break-before: auto; }
        }
      `}</style>

      <div className="no-print" style={{ maxWidth: '680px', margin: '0 auto 16px', display: 'flex', gap: '9px' }}>
        <button onClick={() => navigate(-1)} style={btnGhost}>← Rudi</button>
        <button onClick={() => window.print()} style={btn}>🖨️ Chapisha / Pakua PDF</button>
      </div>

      <div className="sheet" style={{
        maxWidth: '680px', margin: '0 auto', background: '#fff', borderRadius: '16px',
        border: '1px solid #E8E4DA', padding: '32px 28px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '26px' }}>
          <div style={{ fontSize: '11px', letterSpacing: '2px', color: '#6B7280', fontWeight: 800 }}>
            IYANNA FOUNDATION RATING (IFR)
          </div>
          <div style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: '24px', color: '#14452F', marginTop: '6px' }}>
            Orodha Rasmi ya Rating
          </div>
          <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '6px' }}>
            {period ? <>Imechapishwa {periodLabel(period.periodKey)} · michezo {period.gamesCount || 0}</> : 'Bado hakuna kipindi kilichochapishwa.'}
          </div>
        </div>

        {RATING_CATEGORIES.map(c => {
          const F = fieldsFor(c.key);
          const list = players
            .filter(p => p[F.established])
            .filter(p => isActive(p[F.lastActivePeriod], cur))
            .sort((a, b) => (b[F.ifr] || 0) - (a[F.ifr] || 0));
          return (
            <div key={c.key} className="cat-section" style={{ marginBottom: '28px' }}>
              <div style={{
                fontSize: '12px', fontWeight: 800, color: '#fff', background: c.color,
                padding: '8px 14px', borderRadius: '9px', display: 'inline-block', marginBottom: '12px',
              }}>
                {c.label.toUpperCase()} · WACHEZAJI {list.length}
              </div>
              {list.length === 0 ? (
                <div style={{ fontSize: '12.5px', color: '#9CA3AF' }}>Bado hakuna mchezaji mwenye rating rasmi ya {c.label}.</div>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ borderBottom: `2px solid ${c.color}` }}>
                      <th style={thP}>#</th>
                      <th style={{ ...thP, textAlign: 'left' }}>Jina</th>
                      <th style={{ ...thP, textAlign: 'left' }}>Club / Shule</th>
                      {c.key === 'classical' && <th style={thP}>Title</th>}
                      <th style={thP}>Rating</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((p, i) => (
                      <tr key={p.id} style={{ borderBottom: '1px solid #E8E4DA' }}>
                        <td style={{ ...tdP, textAlign: 'center', color: i === 0 ? '#B45309' : '#6B7280', fontWeight: 800 }}>{i + 1}</td>
                        <td style={{ ...tdP, fontWeight: 700 }}>{p.fullName}</td>
                        <td style={{ ...tdP, color: '#6B7280' }}>{p.clubName || p.school || '—'}</td>
                        {c.key === 'classical' && <td style={{ ...tdP, textAlign: 'center', color: '#B45309', fontWeight: 700 }}>{p.title || ''}</td>}
                        <td style={{ ...tdP, textAlign: 'center', fontWeight: 800, color: c.color }}>{p[F.ifr]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          );
        })}

        <div style={{ marginTop: '10px', paddingTop: '14px', borderTop: '1px solid #E8E4DA', fontSize: '10.5px', color: '#9CA3AF', textAlign: 'center' }}>
          Imetolewa {fmtDate(new Date())} · Iyanna Foundation · Rating zinachapishwa tarehe 1 ya kila mwezi
        </div>
      </div>
    </div>
  );
}

const btn = {
  background: 'linear-gradient(135deg, #14452F, #1F6B45)', color: '#fff', border: 'none',
  padding: '11px 18px', borderRadius: '10px', fontSize: '13px', fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit',
};
const btnGhost = {
  background: '#fff', color: '#14452F', border: '1px solid #E8E4DA',
  padding: '11px 16px', borderRadius: '10px', fontSize: '13px', fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit',
};
const thP = { padding: '8px 6px', fontSize: '10.5px', color: '#6B7280', fontWeight: 800, textAlign: 'center' };
const tdP = { padding: '8px 6px' };
